module.exports = __webpack_public_path__ + "img/129ne.e8484162.svg";